module.exports = __webpack_public_path__ + "img/green_arrow_left.19da74d0.png";